import { RiskAssessmentDTO } from '@behavior/activity/dto/RiskAssessmentDTO';
import ReportAccordion from '../common/ReportAccordion';
import ReportChoices from '../common/ReportChoices';
import ReportDetail from '../common/ReportDetail';
import ReportFlex from '../common/ReportFlex';
import InputWithLabel from '../common/InputWithLabel';
import RiskAssessmentIgnitionSourceTable from './RiskAssessmentIgnitionSourceTable';
import InputWithChoice from '../common/InputWithChoice';

export const RiskAssessmentReportAccordian = ({
  riskAssessment,
}: {
  riskAssessment: RiskAssessmentDTO;
}) => {
  return (
    <ReportAccordion header="risk.assessment.details.page.risk.details.container.title">
      <ReportFlex spacedLarge>
        <ReportFlex column spacedLarge></ReportFlex>
      </ReportFlex>
      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.category.of.substance"
        showSeparator
      >
        <ReportChoices
          otherKey="other"
          otherTxtKey="otherTxt"
          values={riskAssessment.riskAssessmentContainer.flammableCategory}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox.category"
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.affected.group"
        showSeparator
      >
        <ReportChoices
          otherKey="other"
          otherTxtKey="otherTxt"
          values={riskAssessment.riskAssessmentContainer.affectedGroup}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox.affected.group"
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.measures"
        showSeparator
      >
        <ReportChoices
          otherKey="other"
          otherTxtKey="otherTxt"
          values={riskAssessment.riskAssessmentContainer.preventionMeasures}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox.measures"
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.organisationalMeasures"
        showSeparator
      >
        <ReportChoices
          values={riskAssessment.riskAssessmentContainer.organisationalMeasures}
          edmsKey="edmsOrganisationalMeasures"
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox.organisationalMeasures"
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.mitigation"
        showSeparator
      >
        <ReportChoices
          otherKey="other"
          otherTxtKey="otherTxt"
          values={riskAssessment.riskAssessmentContainer.mitigationMeasures}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox.mitigation"
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.workerTrainingInformation"
        showSeparator
      >
        <ReportChoices
          otherKey="other"
          otherTxtKey="otherTxt"
          values={riskAssessment.riskAssessmentContainer.workerTrainingInformation}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox.workerTrainingInformation"
        />
      </ReportDetail>
      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.atexZone.title"
        showSeparator
      >
        <InputWithLabel
          label="risk.assessment.details.page.risk.details.container.atexZone.label"
          placeholder="risk.assessment.details.page.risk.details.container.atexZone.placeholder"
          value={riskAssessment.riskAssessmentContainer.edmsAtexZone}
          isEdms
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.esi"
        showSeparator
      >
        <InputWithChoice
          choices={['yes', 'no']}
          selectedValue={riskAssessment.riskAssessmentContainer.electricalSafetyInspectionPerformed}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox"
        />
        <InputWithLabel
          placeholder="risk.assessment.details.page.risk.details.container.checkbox.esi.placeholder"
          value={riskAssessment.riskAssessmentContainer.edmsESI}
          isEdms
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.leakTested"
        showSeparator
      >
        <InputWithChoice
          choices={['yes', 'no']}
          selectedValue={riskAssessment.riskAssessmentContainer.leakTested}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox"
        />
      </ReportDetail>
      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.checkbox.title.warningNotices"
        showSeparator
      >
        <InputWithChoice
          choices={['yes', 'no']}
          selectedValue={riskAssessment.riskAssessmentContainer.hasWarningNotices}
          baseMessage="risk.assessment.details.page.risk.details.container.checkbox"
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.table.title"
        showSeparator
      >
        <RiskAssessmentIgnitionSourceTable
          sourcePresentLikelihood={riskAssessment.riskAssessmentContainer.sourcePresent!}
          ignitionLikelihood={riskAssessment.riskAssessmentContainer.ignitionLikelihood!}
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.additionalInformation.title"
        showSeparator
      >
        <InputWithLabel
          value={riskAssessment.riskAssessmentContainer.additionalInf}
          placeholder="risk.assessment.details.page.risk.details.container.additionalInformation.title"
        />
      </ReportDetail>

      <ReportDetail
        header="risk.assessment.details.page.risk.details.container.workEquipment.title"
        showSeparator={false}
      >
        <InputWithLabel
          value={riskAssessment.riskAssessmentContainer.workEquipmentAndMaterialsInfo}
          placeholder="risk.assessment.details.page.risk.details.container.workEquipment.title"
        />
      </ReportDetail>
    </ReportAccordion>
  );
};
